/**
 * Public Journey member-facing presentation helpers (UX-04-A).
 * Reuses Planning activity-type SSOT; does not translate UGC titles/places.
 */

import {
  ACTIVITY_TYPE_PRODUCT_LABELS,
  activityTypeProductLabel,
} from '../journey-planning/planningPresentation';

const MEMORY_TYPE_PRODUCT_LABELS = Object.freeze({
  STORY: '故事',
  PHOTO: '照片',
  NOTE: '筆記',
  CHECK_IN: '打卡',
});

export function publicTimelineTypeLabel(item) {
  const activityType = String(item?.activityType || '').trim();
  if (activityType && Object.prototype.hasOwnProperty.call(ACTIVITY_TYPE_PRODUCT_LABELS, activityType)) {
    return activityTypeProductLabel(activityType);
  }

  const memoryType = String(item?.memoryType || '').trim();
  if (memoryType) {
    return MEMORY_TYPE_PRODUCT_LABELS[memoryType] || '旅程回憶';
  }

  const itemType = String(item?.type || '').trim();
  if (itemType === 'MEMORY') return '旅程回憶';
  return '行程安排';
}

/** 呈現層翻譯用 key（與 publicTimelineTypeLabel 同一判斷順序）。 */
export function publicTimelineTypeLabelKey(item) {
  const activityType = String(item?.activityType || '').trim();
  if (activityType && Object.prototype.hasOwnProperty.call(ACTIVITY_TYPE_PRODUCT_LABELS, activityType)) {
    return `travel.publicJourney.type.activity.${activityType}`;
  }
  const memoryType = String(item?.memoryType || '').trim();
  if (memoryType) {
    return Object.prototype.hasOwnProperty.call(MEMORY_TYPE_PRODUCT_LABELS, memoryType)
      ? `travel.publicJourney.type.memory.${memoryType}`
      : 'travel.publicJourney.type.memory.default';
  }
  if (String(item?.type || '').trim() === 'MEMORY') return 'travel.publicJourney.type.memory.default';
  return 'travel.publicJourney.type.plan';
}
